import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getUQCMasters = createAsyncThunk(
  "UQCMaster/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.UQC_MASTER.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUQCMaster = createAsyncThunk(
  "UQCMaster/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.UQC_MASTER.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteUQCMaster = createAsyncThunk(
  "UQCMaster/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.UQC_MASTER.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editUQCMaster = createAsyncThunk(
  "UQCMaster/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.UQC_MASTER.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const toggleUQCMasterActive = createAsyncThunk(
  "UQCMaster/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(`${API_URL.UQC_MASTER.SLUG}/${id}/toggle-active`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getActiveUQCCodes = createAsyncThunk(
  "UQCMaster/getActive",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${API_URL.UQC_MASTER.ACTIVE}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const uqcMasterSlice = createSlice({
  name: "uqcMaster",
  initialState: {
    uqc_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUQCMasters.fulfilled, (state, action) => {
      state.uqc_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  uqcMasterSlice.actions;
export default uqcMasterSlice.reducer;
